// Libraries
import React, { useState } from 'react'
import PropTypes from 'prop-types'

// Components
import Modal from 'ui/Modal'
import Text from 'ui/Text'

// Icons
import IconFinger from 'ui/Icons/IconFinger'
import Row from 'ui/Row'
import Col from 'ui/Col'
import Space from 'ui/Space'
import Divider from 'ui/Divider'

// Helpers
import { resolveAkamaiUrl } from 'helpers/auth'

// Constant
import { PROVIDERS } from 'constants/keys'

function PopupSocialLogin({ onClickLogin, ...props }) {
  const [visible, setVisible] = useState(true)

  const onSocialLoginClick = (provider) => {
    // Redirect to akamai
    const akamaiUrl = resolveAkamaiUrl(provider)

    if (akamaiUrl) {
      window.open(akamaiUrl, '_self')
    }
  }

  return (
    <Modal show={visible} style={{ textAlign: 'center' }} {...props}>
      <Row noGutters>
        <Col xs={{ vcenter: true, span: 12 }}>
          <IconFinger />
        </Col>
        <Col xs={{ span: 12 }}>
          <Text color="#000" paddingTop={10}>
            You’ve previously signed in with one of the apps below.
          </Text>
          <Text color="#000" paddingBottom={35}>
            Please select to proceed
          </Text>
        </Col>
        <Col xs={{ span: 12, vcenter: true }}>
          <Space>
            {PROVIDERS.map((x, index) => {
              return (
                <x.icon
                  key={index}
                  onClick={() => onSocialLoginClick(x.provider)}
                ></x.icon>
              )
            })}
          </Space>
        </Col>
      </Row>
      <Divider style={{ width: '90%', borderColor: '#9a9a9a' }} />
      <Text
        color="#5BADFA"
        size={15}
        clickable
        onClick={() => {
          setVisible(false)
          onClickLogin()
        }}
      >
        Login with a different email address
      </Text>
    </Modal>
  )
}

PopupSocialLogin.propTypes = {
  onClickLogin: PropTypes.func,
}

PopupSocialLogin.defaultProps = {
  onClickLogin: () => {},
}

export default PopupSocialLogin
